export const root = 'https://ewriteassist.com'


// WEBPACK FOOTER //
// ./src/constants.js